import BaseService from "./BaseService";

class LandingPageConfigsService {
    static async getLandingPageConfigs(id, token) {
        try {
            return await BaseService.get(`landing-page-configs/${id}`, token);
        }
        catch (error) {
            console.error("Erro ao buscar configurações da landing page!", error.response.data.error[0]);
            throw error.response.data.error[0];
        }
    }
}

export default LandingPageConfigsService;

